import { useQuery } from "@tanstack/react-query";

import { getFarmPayments } from "services";

import { getFarmIdFromLocalStorage } from "utils";

import { DEFAULT_CACHE_TIME, GET_FARM_PAYMENTS } from "consts";

import { FarmPaymentsResponse } from "models";

export const useGetFarmPayments = (enabled: boolean) => {
  const farmId = getFarmIdFromLocalStorage();

  return useQuery<FarmPaymentsResponse>({
    queryKey: [GET_FARM_PAYMENTS, farmId],
    queryFn: getFarmPayments,
    enabled,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
